import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import HowItWorks from "../components/HowItWorks";
import TravelRewards from "../components/TravelRewards";
import Tokenomic from "../components/Tokenomic";
import Roadmap from "../components/Roadmap";
import Footer from "../components/Footer";

function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <HowItWorks />
      <TravelRewards />
      <Tokenomic />
      <Roadmap />
      <Footer />
    </>
  );
}

export default Home;